/**
 * Builds the MC1 web-app deep link that opens a claim's case.
 *
 * `baseUrl` must include the environment's context root — e.g. prod
 * `http://prodmcl.mclarensone.com/mc1`, dev9
 * `https://devmcl.mclarensone.com/devenv9` — because each MC1 environment is
 * served under a different root. `caseId` is the internal TOCCase id
 * (ClaimResponse.caseId), e.g. claim MUK.160366 → caseId 704777.
 */
export function buildMc1ClaimUrl(baseUrl: string, caseId: number): string {
  let base = baseUrl
  while (base.endsWith('/')) base = base.slice(0, -1)
  return `${base}/mclarens/sharedpages/casemanager/main/mclopencasetransparentpage.jsp?URLInvokedExternally=true&CaseID=${caseId}`
}
